module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C191"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('p', {
    staticClass: "C192"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/05_Acknowle#page_vi"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "C193"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduc#page_2"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "C193"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduc#page_2"
    }
  }, [_vm._v("The Sidelong World")])]), _vm._v(" "), _c('p', {
    staticClass: "C193"
  }, [_c('em', [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduc#page_2"
    }
  }, [_vm._v("Where Confession and Proclamation")])])]), _vm._v(" "), _c('p', {
    staticClass: "C179"
  }, [_c('em', [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduc#page_2"
    }
  }, [_vm._v("Are Compounded")])])]), _vm._v(" "), _c('p', {
    staticClass: "C193"
  }, [_vm._v("CARLOS MONSIVÁIS")]), _vm._v(" "), _c('p', {
    staticClass: "C179"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Pillar_o#page_46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pillar of Salt")])]), _vm._v(" "), _c('p', {
    staticClass: "C193"
  }, [_vm._v("SALVADOR NOVO")]), _vm._v(" "), _c('p', {
    staticClass: "C193"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08__This_fl#page_151",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“This flower of fourteen petals”")])]), _vm._v(" "), _c('p', {
    staticClass: "C179"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08__This_fl#page_151",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Salvador Novo and the Sonnet")])])]), _vm._v(" "), _c('p', {
    staticClass: "C193"
  }, [_vm._v("MARGUERITE FEITLOWITZ")]), _vm._v(" "), _c('p', {
    staticClass: "C179"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Sonnets#page_155",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sonnets")])]), _vm._v(" "), _c('p', {
    staticClass: "C192"
  }, [_vm._v("SALVADOR NOVO")]), _vm._v(" "), _c('p', {
    staticClass: "C193"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Notes#page_195",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NOTES")])]), _vm._v(" "), _c('p', {
    staticClass: "C193"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Index#page_203",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INDEX")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-942657b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Contents.vue
// module id = 69
// module chunks = 0